import { displayProperty } from "../../../../utils/properties";
import React from "react";
import { Part } from "../../../../reducers/models/parts";
import InfoItem from "./InfoItem";
import { CURRENCY } from "../../../../reducers/uploadedBoard";
import { formatSmallCurrency } from "../../../../utils/valueFormatting";
import Link from "next/link";
import Button from "../../../common/Button";
import { Container, InfoLine, InventoryContainer } from "./PartDetailsStyles";
import PartImage from "../../../PartImage";
import PartPropertiesUpdate from "../../../internal/BoardInventory/UpdatePartPropertiesCell";
import InfoIcon from "../../../common/FlashPCBTooltip/InfoIcon";
import FlashPCBTooltip from "../../../common/FlashPCBTooltip";

export default function PartDetails({
  part,
  canEditPart,
}: {
  part: Part;
  canEditPart: boolean;
}) {
  return (
    <Container>
      <InfoItem label={"Part Description"} value={part.short_description} />
      {part.manufacturer && (
        <InfoItem label={"Manufacturer"} value={part.manufacturer} />
      )}
      {canEditPart && <PartPropertiesUpdate part={part} />}
      <InfoLine>
        {part.properties.map((property) => {
          return (
            <InfoItem
              key={property.raw}
              label={property.parameter.name}
              value={displayProperty(property)}
            />
          );
        })}
      </InfoLine>
      <InventoryContainer>
        <InfoItem
          label={
            <FlashPCBTooltip
              content={
                "Availability of parts may decrease under shorter project lead times"
              }
            >
              Quantity Available <InfoIcon />
            </FlashPCBTooltip>
          }
          value={part.inventory_level?.toLocaleString() || "NA"}
        />
        <InfoItem
          label={"Unit Price"}
          value={
            part.price_info !== null && (part.inventory_level || 0) > 0
              ? formatSmallCurrency(
                  part.price_info.unit_price,
                  part.price_info.currency as CURRENCY,
                )
              : "NA"
          }
        />
        <InfoItem
          label={"Reel width (mm)"}
          value={part.reel_details.reel_width_mm || "Unknown"}
        />
        <InfoItem
          label={"Reel pitch (mm)"}
          value={part.reel_details.reel_pitch_mm || "Unknown"}
        />
      </InventoryContainer>
      <PartImage part={part} />
      {part.datasheet_url && (
        <Link
          href={part.datasheet_url}
          target="_blank"
          rel="noopener noreferrer"
          passHref
        >
          <Button
            label={"Download Datasheet"}
            leftIconProps={{ src: "/icons/download.svg", alt: "download" }}
            centerText
            styleProps={{ width: "100%" }}
          />
        </Link>
      )}
    </Container>
  );
}
